module.exports = __webpack_public_path__ + "img/2111251418.37c7c981.png";